/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import {
  TransferAllocateService,
  Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto,
} from '../../services/wealthlane-award-services';
import { TableParams } from '../../types/common';

const useGetTransferAllocateDashboard = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<
  Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto[] | undefined,
  unknown
> => {
  const { transferStatusIds, containerStatusIds, companyId, _force } = tableInfo;
  const transferAllocateDashboard = useQuery(
    ['useGetTransferAllocateDashboard', transferStatusIds, containerStatusIds, companyId, _force],
    async () => {
      return await handleRequest(
        TransferAllocateService.getApiAwardApiAppTransferAllocateTransferAllocateDashboard(
          [transferStatusIds],
          [containerStatusIds],
          companyId
        )
      );
    }
  );

  return transferAllocateDashboard;
};

export default useGetTransferAllocateDashboard;
